import { actions } from "@ehi/global-marketing-interface";

export const setCoupon = (code) => (dispatch) => {
    if (code) {
        dispatch(actions.reservations.initiateState.set('coupon', { code }));
    } else {
        dispatch(actions.reservations.initiateState.unset('coupon'));
    }
};